import React, {useState, useEffect, useCallback} from 'react';
import {useParams} from 'react-router-dom';
import {IoIosHeartEmpty} from "react-icons/io";
import {IoHeart} from "react-icons/io5";
import filterIcon from '../../assets/images/filter-icon.svg';
import {calculateDiscountedPrice, renderStars} from '../../utils/functions';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Navbar from "../../components/navbar/Navbar.tsx";
// import Footer from "../../components/footer/Footer.tsx";
// import Header from "../../components/header/Header.tsx";
import {IoIosArrowForward} from "react-icons/io";
import {MdKeyboardArrowUp, MdKeyboardArrowDown} from "react-icons/md";
import {useLocation} from "react-router-dom";
import { getFetcher, postFetcher } from '../../../api/fetchers.ts';
import { endpoints } from '../../../api/endpoints.ts';
import {useNavigate} from 'react-router-dom';
import { useUser } from '../../context/UserContext.tsx';
import Spinner from '../../components/spinner/Spinner.tsx';
import { FaChevronCircleDown } from "react-icons/fa";
import { useCurrency } from '../../context/CurrencyContext.tsx';
import { useLanguage } from '../../context/LanguageContext.tsx';


interface B2B {
    id: string;
    name: string;
    ratio: number;
}


const CategoriesDetail: React.FC = () => {
    const { t } = useLanguage();
    const { exchangeRate } = useCurrency();
    const {user, addFavoriteProduct, removeFavoriteProduct} = useUser();
    const {subCategoryName} = useParams();
    const location = useLocation();
    const {categoriesIds} = location.state || {};
    const {locationUser} = location.state || {}
    const [catId] = useState(categoriesIds[0])
    const [subCatId] = useState(categoriesIds[1] ? categoriesIds[1] : 0)
    const decodedSubCategoryName = decodeURIComponent(subCategoryName || '');
    const [isOpen, setIsOpen] = useState(true);
    const [isColorsOpen, setIsColorsOpen] = useState(true);
    const [isWeightsOpen, setIsWeightsOpen] = useState(true);
    const [isLitresOpen, setIsLitresOpen] = useState(true);
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [selectedSizes, setSelectedSizes] = useState<string[]>([]);
    const [selectedColors, setSelectedColors] = useState<string[]>([]);
    const [selectedWeights, setSelectedWeights] = useState<string[]>([]);
    const [selectedLitres, setSelectedLitres] = useState<string[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<string | null>(decodedSubCategoryName);
    const [categoryProducts, setCategoryProducts] = useState<any>([]);
    const [categoriesData, setCategoriesData] = useState<any>([]);
    const [categoryId, setCategoryId] = useState<any>(catId);
    const [selectedCategoryId, setSelectedCategoryId] = useState<any>(0);
    const [selectedCategoryName, setSelectedCategoryName] = useState<any>(0);
    const [subCategoryChange, setSubCategoryChange] = useState<any>(1);
    const [isCategoryOpen, setIsCategoryOpen] = useState(false);
    const [favoriteProductIds, setFavoriteProducts] = useState<Set<string>>(new Set<string>());
    const sizes = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"];
    const colors = ["#000000", "#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F", "#90BE6D", "#43AA8B", "#577590", "#277DA1", "#4D908E", "#A2D2FF", "#E09F3E"];
    const weights = ["50gr", "125gr", "250gr", "500gr", "1 KG", "2 KG", "5 KG", "10 KG", "+10 KG"];
    const litres = ["50ml", "125ml", "250ml", "500ml", "1 LT", "2 LT", "5 LT","10 LT", "+10 LT"];
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState<number>(0);
    const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();


    const navigate = useNavigate();

    useEffect(() => {
        if(subCategoryName){
            setSelectedCategory(decodedSubCategoryName);
        }
    }, [subCategoryName, decodedSubCategoryName]);


    // LIKE PRODUCT TOGGLE
    const toggleLike = useCallback(async (id: string, productName: string) => {
        if (!user) {
            toast.error(t('toastMessage', 'campErr'));
            return;
        }
        const isLiked = favoriteProductIds.has(id);

        try {
            if (isLiked) {
                await removeFavoriteProduct(id);
                setFavoriteProducts(prevIds => {
                    const newIds = new Set(prevIds);
                    newIds.delete(id);
                    return newIds;
                });
                toast.info(`${productName} ${t('toastMessage', 'addBasketFavInfo')}`);
            } else {
                await addFavoriteProduct(id);
                setFavoriteProducts(prevIds => {
                    const newIds = new Set(prevIds);
                    newIds.add(id);
                    return newIds;
                });
                toast.success(`${productName} ${t('toastMessage', 'addBasketFavSuc')}`);
            }
        } catch (error) {
            toast.error('Error');
        }
    }, [favoriteProductIds, addFavoriteProduct, removeFavoriteProduct]);


    // change category id and selected category
    const handleClickCategory = (category:any) => {
        setSelectedCategoryId(category.id ? category.id : catId);
        setSelectedCategoryName(category.name);
        selectedCategoryName!= category.name && isCategoryOpen == true ? null : setIsCategoryOpen(!isCategoryOpen);
    }
    const handleClickSubCategory = (subCategory:any) => {
        setCategoryId(subCategory.id ? subCategory.id : subCatId);
        setSelectedCategory(subCategory.name);
        setPagination(0);
        // window.location.reload();
    }
 
    // get categoriesData
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                if (user || locationUser) {
                    try {
                        const businessPackage = await getFetcher(endpoints.user.getBusinessPackageById.replace('{id}', user?.businessPackageId || locationUser?.businessPackageId));
                        if (businessPackage.result) {
                            setUserBusinessPackage(businessPackage.businessPackage);
                        }
                    } catch (error) {
                        console.error('Error fetching favorites:', error);
                    }
                }

                setLoading(true);
                const response = await getFetcher(endpoints.products.getProductCategory);
                if (response.result) {
                    const categoriesWithSubCategories = await Promise.all(response.productCategories.map(async (category: any) => {
                        const subCategoriesResponse = await getFetcher(endpoints.products.getProductSubCategoriesByCategoryId.replace('{id}', category.id.toString()));
                        return {
                            ...category,
                            subCategories: subCategoriesResponse.result ? subCategoriesResponse.productSubCategories : []
                        };
                    }));
                    setCategoriesData(categoriesWithSubCategories);
                    setLoading(false);
                } else {
                    console.log(response.message);
                }

                
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, [selectedCategory]);





    // change catId from navbar
    useEffect(() => {
        if (subCatId !== undefined) {
            setSubCategoryChange(subCatId);
        }
        else if (catId !== undefined) {
            setSubCategoryChange(catId);
        }
    }, [subCatId, catId]);

    


    // change categoryId from sideBar
    useEffect(() => {
        if (categoryId !== undefined) {
            setSubCategoryChange(categoryId);
        }
    }, [categoryId]);


    const fetchProducts = async () => {
        try {
            const productsResponse = await postFetcher(endpoints.products.productsSubCategoryId, {
                arg: {
                    subCategoryId: subCategoryChange,
                    pageNumber: pagination,
                }
            });
            if (productsResponse.result) {
                setCategoryProducts((prevProducts: any) => [...prevProducts, ...productsResponse.products]);
            }
            else {
                console.error('Error fetching products:', productsResponse.message);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchFavorites = async () => {
        if (user) {
            try {
                const favoritesResponse = await getFetcher(`${endpoints.user.getFavorites}/${user.id}`);
                if (favoritesResponse.result) {
                    const favoriteIds = new Set<string>(favoritesResponse.favoriteProducts.map((favoriteProduct: any) => favoriteProduct.productId));
                    setFavoriteProducts(favoriteIds);
                }
            } catch (error) {
                console.error('Error fetching favorites:', error);
            }
        }
    };

    // get products by category
    useEffect(() => {
        setCategoryProducts([]); 
        setPagination(0);  
        fetchProducts();
    }, [subCategoryChange]);
    
    useEffect(() => {
        if (pagination > 0) {
            fetchProducts();
            fetchFavorites();
        }
    }, [pagination]); 
    

    const handleSizeClick = (size: string) => {
        setSelectedSizes((prevSelectedSizes) => {
            if (prevSelectedSizes.includes(size)) {

                return prevSelectedSizes.filter((s) => s !== size);
            } else {

                return [...prevSelectedSizes, size];
            }
        });
    };

    const handleColorClick = (color: string) => {
        setSelectedColors((prevSelectedColors) => {
            if (prevSelectedColors.includes(color)) {

                return prevSelectedColors.filter((c) => c !== color);
            } else {

                return [...prevSelectedColors, color];
            }
        });
    };

    const handleWeightClick = (weight: string) => {
        setSelectedWeights((prevSelectedWeight) => {
            if (prevSelectedWeight.includes(weight)) {

                return prevSelectedWeight.filter((w) => w !== weight);
            } else {

                return [...prevSelectedWeight, weight];
            }
        });
    };

    const handleLitreClick = (litre: string) => {
        setSelectedLitres((prevSelectedLitre) => {
            if (prevSelectedLitre.includes(litre)) {

                return prevSelectedLitre.filter((l) => l !== litre);
            } else {

                return [...prevSelectedLitre, litre];
            }
        });
    };

    // const filteredProducts = () => {
    //     return categoryProducts.filter((product:any) => {
    //       let productAttributes:any = {};
      
    //       try {
    //         productAttributes = (product.attributes);
    //       } catch (error) {
    //         return false;
    //       }
      
    //       const productSizes = productAttributes?.Size?.values || [];
    //       const productColors = productAttributes?.Color?.values || [];
    //       const productWeights = productAttributes?.Weight?.values || [];
    //       const productLitres = productAttributes?.Litre?.values || [];

    //       console.log(productWeights)
      
    //       return selectedSizes.length>0 || selectedColors.length>0 || selectedWeights.length>0 || selectedLitres.length>0 ?
          
    //       (selectedSizes.length>0 ? (selectedSizes.some((selectedSize) =>
    //         productSizes.includes(selectedSize)))
    //     :true
    //     ) &&
    //       (selectedColors.length>0 ? selectedColors.some((selectedColor) =>
    //             productColors.includes(selectedColor)
    //           )
    //           :true
    //       ) &&
    //       (selectedWeights.length>0 ? selectedWeights.some((selectedWeight) =>
    //         productWeights.includes(selectedWeight)
    //           )
    //           :true
    //       ) &&
    //       (selectedLitres.length>0 ? selectedLitres.some((selectedLitre) =>
    //         productLitres.includes(selectedLitre)
    //           )
    //           :true
    //       )

    //       : categoryProducts
    //     });
    //   };

    // PAGINATION 
    const handleClickPaginationFn = () => {
        setPagination(prevPagination => prevPagination + 1);
    };


    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick rtl={false}
                            pauseOnFocusLoss draggable pauseOnHover/>
            {/* <Header/>
            <Navbar/> */}
            <main className="w-full md:px-12 px-4 py-12 pt-3 flex flex-col md:flex-row justify-center ">
                {/* SIDEBAR */}

                {isFiltersOpen ? (
                    <section
                        className="md:w-[300px] h-[calc(100vh-164px)] max-h-[80vh] shadow-lg rounded-lg bg-white mt-8 ">
                        <div className="h-5/6  overflow-y-auto">
                            <div className="flex justify-between w-full items-center px-4">
                                <p className="p-2 font-bold">Filtreler</p>
                                <img src={filterIcon}
                                     onClick={() => setIsFiltersOpen(false)}
                                     className="pr-4 cursor-pointer w-8 h-8 md:w-10 md:h-10 mr-2 md:mr-0"
                                     alt="filter icon"/>
                            </div>
                            {/* BORDER */}
                            <div className="border-b-2 border-color-gray pt-3 w-4/5 mx-auto"></div>
                            {/* CATEGORIES */}
                            <div className=" p-4 gap-2">
                                {categoriesData.map((category:any, categoryIndex: number) => (
                                    <div key={categoryIndex}
                                         
                                         className={` px-3 text-color-opacity cursor-pointer ${selectedCategoryName === category.name ? 'text-primary-color' : ''} `}>
                                       <div
                                       className="flex flex-row justify-between w-full"
                                       onClick={() => handleClickCategory(category)}
                                       >
                                       <div className="items-start flex"><p className="text-start">{category.name}</p> </div>
                                       <div className="justify-end flex mt-1"><IoIosArrowForward /></div>
                                        </div> 
                                         {isCategoryOpen && category?.subCategories.map((subCategory:any, index: number) =>selectedCategoryId == subCategory.mainCategoryId && (
                                    <div key={index}
                                         onClick={() => handleClickSubCategory(subCategory)}
                                         className={`ml-4 mb-4 flex flex-row justify-between w-full mt-4 text-color-opacity cursor-pointer ${selectedCategory === subCategory?.name ? 'text-primary-color' : ''} `}>
                                        <div className="flex items-start"><p>-{subCategory?.name}</p></div>
                                        <div className="flex justify-end mt-1"><IoIosArrowForward/></div>
                                        
                                        
                                    </div>))} 
                                        
                                    </div>
                                ))}
                            </div>
                            {/* BORDER */}
                            <div className="border-b-2 border-color-gray pt-3 w-4/5 mx-auto"></div>

                            {/* SIZE */}
                            <div>
                                <div className="flex justify-between items-center">
                                    <p className="p-4 font-semibold">Beden</p>
                                    <button onClick={() => setIsOpen(!isOpen)} className="mr-6 text-color-opacity">
                                        {isOpen ? <MdKeyboardArrowDown className="w-6 h-6"/> :
                                            <MdKeyboardArrowUp className="w-6 h-6"/>}
                                    </button>
                                </div>
                                {isOpen && (
                                    <div className="grid grid-cols-4 px-4 gap-2">
                                        {sizes.map((size) => (
                                            <div
                                            onClick={() => handleSizeClick(size)}
                                            >
<p className={`cursor-pointer text-color-opacity border p-2 text-center rounded ${selectedSizes.includes(size) ? 'border-primary-color text-primary-color' : 'border-color-opacity'}`}
                                               key={size} >{size}</p>

                                            </div>
                                            
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* BORDER */}
                            <div className="border-b-2 border-color-gray py-6 w-4/5 mx-auto"></div>

                            {/* COLORS */}
                            <div>
                                <div className="flex justify-between items-center">
                                    <p className="p-4 font-semibold">Renkler</p>
                                    <button onClick={() => setIsColorsOpen(!isColorsOpen)}
                                            className="mr-6 text-color-opacity">
                                        {isColorsOpen ? <MdKeyboardArrowDown className="w-6 h-6"/> :
                                            <MdKeyboardArrowUp className="w-6 h-6"/>}
                                    </button>
                                </div>
                                {isColorsOpen && (
                                    <div className="grid grid-cols-6 gap-2 px-4">
                                        {colors.map((color, index) => (
                                            <div
                                                key={index}
                                                className={`cursor-pointer w-8 h-8 rounded-full ${selectedColors.includes(color) ? 'border border-black' : 'border-6'}`}
                                                style={{backgroundColor: color}}
                                                onClick={() => handleColorClick(color)}
                                            >
                                                </div>
                                        ))}
                                    </div>
                                )}
                                {/*BORDER*/}
                                <div className="border-b-2 border-color-gray py-6 w-4/5 mx-auto"></div>
                            </div>

                            {/* WEIGHTS */}
                            <div>
                                <div className="flex justify-between items-center">
                                    <p className="p-4 font-semibold">Ağırlıklar</p>
                                    <button onClick={() => setIsWeightsOpen(!isWeightsOpen)} className="mr-6 text-color-opacity">
                                        {isWeightsOpen ? <MdKeyboardArrowDown className="w-6 h-6"/> :
                                            <MdKeyboardArrowUp className="w-6 h-6"/>}
                                    </button>
                                </div>
                                {isWeightsOpen && (
                                    <div className="grid grid-cols-3 px-4 gap-2">
                                        {weights.map((weight) => (
                                            <div
                                            onClick={() => handleWeightClick(weight)}
                                            >
<p className={`cursor-pointer text-color-opacity border p-2 text-center rounded ${selectedWeights.includes(weight) ? 'border-primary-color text-primary-color' : 'border-color-opacity'}`}
                                               key={weight} >{weight}</p>

                                            </div>
                                            
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* BORDER */}
                            <div className="border-b-2 border-color-gray py-6 w-4/5 mx-auto"></div>

                            {/* LITRES */}
                            <div>
                                <div className="flex justify-between items-center">
                                    <p className="p-4 font-semibold">Litreler</p>
                                    <button onClick={() => setIsLitresOpen(!isLitresOpen)} className="mr-6 text-color-opacity">
                                        {isLitresOpen ? <MdKeyboardArrowDown className="w-6 h-6"/> :
                                            <MdKeyboardArrowUp className="w-6 h-6"/>}
                                    </button>
                                </div>
                                {isLitresOpen && (
                                    <div className="grid grid-cols-3 px-4 gap-2">
                                        {litres.map((litre) => (
                                            <div
                                            onClick={() => handleLitreClick(litre)}
                                            >
<p className={`cursor-pointer text-color-opacity border p-2 text-center rounded ${selectedLitres.includes(litre) ? 'border-primary-color text-primary-color' : 'border-color-opacity'}`}
                                               key={litre} >{litre}</p>

                                            </div>
                                            
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* BORDER */}
                            <div className="border-b-2 border-color-gray py-6 w-4/5 mx-auto"></div>
                        </div>
                        {/* APPLY BUTTON */}
                        <div className="flex justify-center w-full sticky bottom-0 h-1/6 py-4  items-end">
                            <button
                                className="text-white bg-primary-color h-12 justify-end w-4/5 text-center text-lg font-bold p-2 rounded-full shadow-md tracking-wider">
                                Uygula
                            </button>
                        </div>

                    </section>
                ) : (
                    /* FILTER BUTTON */
                    <section
                        className="md:w-[300px] h-16 shadow-lg rounded-lg bg-white mt-8 justify-center items-center flex">
                        <div className="flex justify-between w-full items-center px-4 ">
                            <p className="py-2 font-bold">Filtreler</p>
                            <img src={filterIcon}
                                 onClick={() => setIsFiltersOpen(true)}
                                 className="pr-4 cursor-pointer w-8 h-8 md:w-10 md:h-10 mr-2 md:mr-0"
                                 alt="filter icon"/>
                        </div>
                    </section>
                )}

                {/* PRODUCTS */}
                {
                    loading ? <div className="flex-grow p-4 w-[calc(100%-72px)] md:w-[calc(100%-240px)] h-[calc(100vh-160px)] overflow-y-auto self-center"><Spinner/></div>  : (
                        <section
                        className="flex-grow p-4 w-[calc(100%-72px)] md:w-[calc(100%-20px)] h-[calc(100vh-160px)] overflow-y-auto self-center">
                        <p className="text-xl font-semibold text-primary-color">{selectedCategory}</p>
                        <div className="flex flex-wrap gap-2">
                            {categoryProducts?.length === 0 ? <p className=' w-full flex justify-start py-4'>Bu kategoride ürün yoktur.</p> : (
                                 categoryProducts?.map((product: any) => (
                                    <div key={product.id} className="w-72 lg:w-80 h-full p-4">
                                        <div className="h-full flex flex-col justify-between overflow-hidden">
                                            <div
                                                className="w-full flex justify-center rounded-lg relative py-6 bg-color-product-bg">
                                                  {(product.images).map((img: string, index: number) => (
                                                    <img
                                                        key={index}
                                                        src={img}
                                                        alt={`additional-${index}`}
                                                        className="h-64 object-cover rounded-t-lg cursor-pointer"
                                                        onClick={() => navigate(`/product-detail/${product.id}`)} 
                                                    />
                                                ))} 
                                                <button className="absolute top-2 right-2 rounded-full bg-transparent"
                                                        onClick={() => toggleLike(product.id, product.name)}>
                                                    {favoriteProductIds.has(product.id) ? (
                                                        <IoHeart className="text-yellow-300 text-3xl mt-2 mr-2"/>
                                                    ) : (
                                                        <IoIosHeartEmpty className="text-yellow-300 text-3xl mt-2 mr-2"/>
                                                    )}
                                                </button>
                                            </div>
                                            <div className="p-4 flex flex-col justify-between flex-grow">
                                                <h2 onClick={() => navigate(`/product-detail/${product.id}`)} className="text-lg font-bold truncate cursor-pointer">{product.name}</h2>
                                                <div className="flex items-center mt-2">
                                                    <div className="flex items-center">
                                                        {renderStars(product.rating)}
                                                    </div>
                                                </div>
                                                <div className="w-full mt-4 flex justify-between items-end">
                                                    <div className="flex gap-2">
                                                        {product.discount > 0 ? (
                                                            <>
                                                                <p className="text-lg lg:text-2xl font-semibold ">₺{calculateDiscountedPrice(product.price, product.discount, userBusinessPackage ? userBusinessPackage?.ratio : 0, exchangeRate )}</p>
                                                                <p className="text-lg lg:text-2xl font-semibold line-through text-gray-500">₺{product.price}</p>
                                                            </>
                                                        ) : (
                                                            <p className="text-lg lg:text-2xl font-semibold">₺{product.price}</p>
                                                        )}
                                                        <div
                                                            className="w-12 h-8 flex items-center justify-center text-sm bg-red-200 text-red-700 px-4 rounded-3xl">
                                                            {product.discount}%
                                                        </div>

                                                        {userBusinessPackage && (
                                <div
                                    className="w-12 h-8 flex items-center justify-center text-sm bg-green-200 text-green-500 px-4 rounded-3xl">
                                    <p className="text-green-500">B</p>: <p>{userBusinessPackage?.ratio}%</p>
                                </div>
                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                            <div className='flex justify-center items-center w-full  text-white'>
                                 <button onClick={handleClickPaginationFn} className='bg-primary-color w-32 font-semibold rounded flex justify-center gap-x-2 items-center active:scale-95 transform transition-all'>daha fazla <FaChevronCircleDown className='font-bold text-white' size={16}/></button>                            
                             </div>
                    </section>
                    )
                }

            </main>
            {/* <Footer/> */}
        </div>
    );
};

export default CategoriesDetail;
